import { RadioButtonOption, SiteCoreDictionary } from '../types';

export enum ReorderOption {
    YES = 'YES',
    NO = 'NO',
}

export const getReorderOptions = (dictionary: SiteCoreDictionary, userIsHighFraudRisk = false): RadioButtonOption[] => {
    const { reorderOptionYes, reorderOptionNo } = dictionary;
    const optionsArray = [
        {
            id: 'reorderOptionNo',
            value: ReorderOption.NO,
            label: reorderOptionNo,
            ...{
                'data-track-id': 'select-reorder-card-option',
                'data-track-linkname': ReorderOption.NO,
            },
        },
        {
            id: 'reorderOptionYes',
            value: ReorderOption.YES,
            label: reorderOptionYes,
            disabled: userIsHighFraudRisk,
            ...{
                'data-track-id': 'select-reorder-card-option',
                'data-track-linkname': ReorderOption.YES,
            },
        },
    ];
    return optionsArray;
};

export const reorderValueToBooleanValue = (option: string) => option === ReorderOption.YES;

export const booleanOrUndefinedValueToReorderValue = (
    booleanValue: boolean | undefined,
    reorderOptions: RadioButtonOption[],
): string | undefined => {
    if (typeof booleanValue === 'undefined') {
        return undefined;
    }

    const wantedReorderValue = booleanValue ? ReorderOption.YES : ReorderOption.NO;

    return reorderOptions.find(({ value }) => value === wantedReorderValue)?.value;
};
